module.exports = __webpack_public_path__ + "img/clara-barton.1cf62c38.png";